import LocalStorageService from "@/services/LocalStorageService";
import axios from "axios";
import { ElMessage } from "element-plus";

// Use the globally defined apiClient from main.js

let domain = location.origin;
if (domain.includes("localhost")) {
  domain = "https://dev.tr.q19.kz";
}
const apiClient = axios.create({
  baseURL: domain + "/api",
});

export { domain, apiClient };

const localStorageService = LocalStorageService.getService();

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorageService.getAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    if (response.data._success) {
      if (response.config.method === "post") {
        ElMessage({
          message: "Успешно",
          type: "success",
          customClass: "my-custom-message", // add this
          duration: 3000,
        });
      }
    } else if (
      response.config.method === "post" &&
      "_success" in response.data
    ) {
      let message = response.data.message || "Ошибка";
      ElMessage({
        message: message,
        type: "error",
        customClass: "my-custom-message", // add this
        duration: 3000,
      });
    }
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    console.log(error.response?.status, originalRequest?.url);

    if (
      error.response?.status === 401 &&
      originalRequest?.url === `auth/refresh`
    ) {
      localStorageService.clearToken();
      location.hash = "#/auth";
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorageService.getRefreshToken();
      return apiClient
        .post("auth/refresh", { refresh_token: refreshToken })
        .then((res) => {
          const { token } = res.data;
          localStorageService.setAccessToken({ access_token: token });
          apiClient.defaults.headers.common["Authorization"] =
            "Bearer " + token;
          return apiClient(originalRequest);
        });
    }

    return Promise.reject(error);
  }
);

export default apiClient;
